var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-select-wrapper" }, [
    _c("label", { class: _vm.labelClasses }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c(
      "select",
      { attrs: { name: _vm.name } },
      [
        _c("option", { attrs: { value: "" } }),
        _vm._v(" "),
        _vm._l(_vm.options, function(option, index) {
          return _c(
            "option",
            { key: index, domProps: { value: option.value } },
            [_vm._v(_vm._s(option.text))]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }